import { BuildFontString } from "../utils/BuildFontString";
import { Div2Floor } from "../utils/Div2Floor";
import { enumElementDrawStates, enumFillMode, kOCNDarkGrayColor } from "../constants";
import { QElement } from "./QElement";
import { shadeColor } from "../utils/shadeColor";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { TruncateText } from "../utils/TruncateText";
import { SetCtxFont } from "../utils/SetCtxFont";
import { Globals } from "./Globals.js";

export class QStdButton extends QElement {
  constructor() {
    super();
    this.fLabel = "<Not Set>";

    this.fStdFillColor = "#F4F4F4";
    this.fFontSize = 12;
    this.fFontName = "Arial";
    this.fFontColor = "#111111";
    this.fBold = false;
    this.fAlignment = "center";
    this.fMarginH = 2;
    this.fBorderThickness = 1;
  }

  SetStdFillColor(fillColor) {
    this.fStdFillColor = fillColor;
  }

  SetFontSize(fontSize) {
    this.fFontSize = fontSize;
  }

  GetCursor() {
    return "pointer";
  }

  SetFontName(fontName) {
    this.fFontName = fontName;
  }

  SetFontColor(fontColor) {
    this.fFontColor = fontColor;
  }

  SetBold(bold) {
    this.fBold = bold;
  }

  DrawButtonBorder(ctx, sx, sy, sw, sh, etchIt) {
    ctx.strokeRect(sx, sy, sw, sh);
    if (etchIt) {
      ctx.save();
      ctx.globalAlpha = 0.4;
      ctx.strokeStyle = this.fBorderColor ? this.fBorderColor : "#222222";
      ctx.strokeRect(sx + 2, sy + 2, sw - 4, sh - 4);
      ctx.restore();
    }
  }

  DrawAdornment(drawBuffer) {
    // override if you want to
  }

  GetMarginH() {
    return this.fMarginH;
  }

  SetMarginH(marginH) {
    this.fMarginH = marginH;
  }

  GetHAlignment() {
    return this.fAlignment;
  }

  SetHAlignment(alignment) {
    this.fAlignment = alignment;
  }

  GetTruncLabel() {
    return this.fTruncLabel;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    var buttonFillStyle = this.fStdFillColor;
    var buttonStrokeStyle = this.fBorderColor ? this.fBorderColor : kOCNDarkGrayColor;
    var txtFillStyle = this.fFontColor;
    var etchIt = false;

    // Draw the button (interior and border)
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        buttonFillStyle = this.fStdFillColor;
        break;
      case enumElementDrawStates.Hover:
        buttonFillStyle = Globals._themeMode.fill.alt;
        if (this.fHighlightColor) buttonFillStyle = this.fHighlightColor;
        break;
      case enumElementDrawStates.MouseDown:
        buttonFillStyle = Globals._themeMode.fill.alt;
        buttonStrokeStyle = Globals._themeMode.fill.alt;
        if (this.fSelectedColor) buttonFillStyle = this.fSelectedColor;
        etchIt = true;
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#AFAFAF";
        buttonStrokeStyle = "#AFAFAF";
        ctx.globalAlpha = 0.6;
        break;
    }

    ctx.fillStyle = buttonFillStyle;
    ctx.strokeStyle = buttonStrokeStyle;
    var thickness = this.GetBorderThickness();
    ctx.lineWidth = thickness;
    var adj = ThicknessAdjuster(thickness);
    var sx = this.fHorzOffset + adj;
    var sy = this.fVertOffset + adj;
    var sw = this.fWidth;
    var sh = this.fHeight;

    if (this.GetFillMode() != enumFillMode.noFill) ctx.fillRect(sx, sy, sw, sh);
    if (thickness > 0) this.DrawButtonBorder(ctx, sx, sy, sw, sh, etchIt);

    ctx.globalAlpha = 1.0;

    // Now Draw the text in the button
    ctx.fillStyle = txtFillStyle;
    var fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    //ctx.font= BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);

    var txt = this.GetTruncLabel(); // fTruncLabel;
    var alignment = this.GetHAlignment();

    var txtHOffset = this.GetMarginH();
    if (alignment == "center")
      txtHOffset = Div2Floor(this.fWidth); // Math.floor(this.fWidth/2);
    else if (alignment == "right") txtHOffset = this.fWidth - this.GetMarginH();
    var txtVOffset = Div2Floor(this.fHeight); // Math.floor(this.fHeight/2);
    ctx.textAlign = alignment;
    ctx.textBaseline = "middle";
    ctx.fillText(txt, this.fHorzOffset + txtHOffset, this.fVertOffset + txtVOffset);

    this.DrawAdornment(drawBuffer);
  }

  DoCalculateMinWidth() {
    var ctx = this.fMeasureBuffer.getContext("2d");

    var fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);
    var txt = this.fLabel;
    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    txtWidth = txtWidth + this.GetMarginH() * 2;
    return txtWidth;
  }

  GetMaxLabelWidth() {
    return this.GetWidth() - this.GetMarginH() * 2;
  }

  SetLabel(theLabel) {
    this.fLabel = theLabel;

    var maxWidth = this.GetMaxLabelWidth();

    var fontInfo = this.fFontString;
    if (!this.fFontString || !this.fFontString.includes("Font Awesome")) {
      fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
      this.fTruncLabel = TruncateText(theLabel, fontInfo, maxWidth);
    } else this.fTruncLabel = this.fLabel;
  }

  GetLabel() {
    return this.fLabel;
  }

  AutoSize() {
    var minWidth = this.CalcMinWidth();
    this.SizeElement(minWidth, this.fHeight);
    this.SetLabel(this.fLabel);
  }

  SetStdDrawStateButtonColors(ctx) {
    var buttonFill = Globals._themeMode.button.fill;
    var buttonStroke = shadeColor(buttonFill, -2);

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        break;
      case enumElementDrawStates.Hover:
        buttonFill = shadeColor(buttonFill, -5);
        break;
      case enumElementDrawStates.MouseDown:
        buttonFill = shadeColor(buttonFill, -10);
        break;
      case enumElementDrawStates.Disabled:
        ctx.globalAlpha = 0.5;
        buttonFill = Globals._themeMode.button.disabled;
        buttonStroke = buttonFill;
        break;
    }
    ctx.strokeStyle = buttonStroke;
    ctx.fillStyle = buttonFill;
  }

  SetStdDrawStateTextColors(ctx) {
    var txtFillStyle = Globals._themeMode.text.header;
    ctx.globalAlpha = 1.0;
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.Hover:
      case enumElementDrawStates.MouseDown:
        break;
      case enumElementDrawStates.Disabled:
        ctx.globalAlpha = 0.9;
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }
    ctx.fillStyle = txtFillStyle;
  }
}
